// schemas/subCategorySchemas.js

export const subCategoryBreadcrumbs = {
  "/product-category/epoxy-resin/": {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": "https://hutaib.org/product-category/epoxy-resin/#breadcrumb",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://hutaib.org/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Construction Chemicals",
        item: "https://hutaib.org/product-category/construction-chemicals",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Epoxy Resin",
        item: "https://hutaib.org/product-category/epoxy-resin",
      },
    ],
  },

  "/product-category/admixture/": {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": "https://hutaib.org/product-category/admixture/#breadcrumb",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://hutaib.org/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Construction Chemicals",
        item: "https://hutaib.org/product-category/construction-chemicals",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Admixture",
        item: "https://hutaib.org/product-category/admixture",
      },
    ],
  },

  "/product-category/rdp-grades/": {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": "https://hutaib.org/product-category/rdp-grades/#breadcrumb",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://hutaib.org/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Construction Chemicals",
        item: "https://hutaib.org/product-category/construction-chemicals",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "RDP Grades",
        item: "https://hutaib.org/product-category/rdp-grades",
      },
    ],
  },

  "/product-category/sbr-grades/": {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": "https://hutaib.org/product-category/sbr-grades/#breadcrumb",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://hutaib.org/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Construction Chemicals",
        item: "https://hutaib.org/product-category/construction-chemicals",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "SBR Grades",
        item: "https://hutaib.org/product-category/sbr-grades",
      },
    ],
  },

  "/product-category/styrene-acrylic/": {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": "https://hutaib.org/product-category/styrene-acrylic/#breadcrumb",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://hutaib.org/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Construction Chemicals",
        item: "https://hutaib.org/product-category/construction-chemicals",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Styrene Acrylic",
        item: "https://hutaib.org/product-category/styrene-acrylic",
      },
    ],
  },

  "/product-category/momentive-amino-functional-fluid/": {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id":
      "https://hutaib.org/product-category/momentive-amino-functional-fluid/#breadcrumb",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://hutaib.org/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Textile Chemical",
        item: "https://hutaib.org/product-category/textile-chemical",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Amino Functional Fluids",
        item: "https://hutaib.org/product-category/momentive-amino-functional-fluid",
      },
    ],
  },

  "/product-category/silicone-oil/": {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": "https://hutaib.org/product-category/silicone-oil/#breadcrumb",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://hutaib.org/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Textile Chemical",
        item: "https://hutaib.org/product-category/textile-chemical",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Block Silicone Fluids",
        item: "https://hutaib.org/product-category/silicone-oil",
      },
    ],
  },

  "/product-category/hydrophilic-oil/": {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": "https://hutaib.org/product-category/hydrophilic-oil/#breadcrumb",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://hutaib.org/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Textile Chemical",
        item: "https://hutaib.org/product-category/textile-chemical",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Hydrophilic",
        item: "https://hutaib.org/product-category/hydrophilic-oil",
      },
    ],
  },

  "/product-category/polydimethylsiloxane/": {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id":
      "https://hutaib.org/product-category/polydimethylsiloxane/#breadcrumb",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://hutaib.org/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Textile Chemical",
        item: "https://hutaib.org/product-category/textile-chemical",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "PDMS Emulsion",
        item: "https://hutaib.org/product-category/polydimethylsiloxane",
      },
    ],
  },

  "/product-category/softeners-for-textile/": {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id":
      "https://hutaib.org/product-category/softeners-for-textile/#breadcrumb",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://hutaib.org/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Textile Chemical",
        item: "https://hutaib.org/product-category/textile-chemical",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Softener",
        item: "https://hutaib.org/product-category/softeners-for-textile",
      },
    ],
  },

  "/product-category/surfactants/": {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": "https://hutaib.org/product-category/surfactants/#breadcrumb",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://hutaib.org/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Textile Chemical",
        item: "https://hutaib.org/product-category/textile-chemical",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Surfactants",
        item: "https://hutaib.org/product-category/surfactants",
      },
    ],
  },

  "/product-category/other-portfolio/": {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": "https://hutaib.org/product-category/other-portfolio/#breadcrumb",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://hutaib.org/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Other Portfolio",
        item: "https://hutaib.org/product-category/other-portfolio",
      },
    ],
  },
};
